var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"text-left mt-10 mb-3",attrs:{"width":"100%","outlined":"","elevation":"1"}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v(_vm._s(_vm.subject))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.content))])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }